<template>
  <div>
    <b-row>
      <b-col sm="4">
        <InputText title="Número" field="number" :formName="formName" :required="true" :maxLength="10"
          v-model="bank.number" :markFormDirty="false" />
      </b-col>
      <b-col sm="8">
        <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="50" v-model="bank.name"
          :markFormDirty="false" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSaveBank" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="saveBank" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/ui/forms/InputText";
import Button from "@/ui/forms/Button";

import Bank from "../../models/Bank";
import BankService from "../../services/bank.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "BankCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: { InputText, Button },
  data() {
    return {
      formName: "bankCreateUpdate",
      bank: new Bank(),
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", [
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
      "addEvent",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    async saveBank() {
      try {
        if (this.bank.id) {
          const response = await BankService.update(this.bank);
          if (response.success) this.addEvent({ name: "bankSaved" });
          if (response.success && !this.registerInSelect) this.hideModal();
          return;
        }

        const response = await BankService.create(this.bank);
        if (response.success) this.addEvent({ name: "bankSaved" });
        if (response.success && !this.registerInSelect) this.hideModal();
        if (response.success && this.registerInSelect) {
          this.$emit("input", {
            id: response.content.id,
            content: response.content.name,
          });
          this.hideVodal(this.formName);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.removeLoading(["btnSaveBank"]);
      }
    },
    update(data) {
      this.bank = new Bank();
      this.bank.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "bankCreate") {
          this.resetValidation(this.formName);
          this.bank = new Bank();
        }
        if (event.name == "bankUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
